<mat-form-field
  [appearance]="appearance"
  class="auto-complete-form"
  (click)="onTouchInput()"
>
  <mat-label>{{ label }}</mat-label>
  <input
    tab-directive
    type="text"
    [placeholder]="label"
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="autoSelect"
    (blur)="onInputBlur()"
  />
  <mat-autocomplete
    #autoSelect="matAutocomplete"
    [displayWith]="displayFn"
    autoActiveFirstOption="true"
    (optionSelected)="onSelectOption($event)"
  >
    @for (option of filteredOptions | async | slice: 0 : 100; track option) {
      <mat-option [value]="option">
        {{ option.name }}
      </mat-option>
    }
  </mat-autocomplete>

  @if (inputControl.errors?.required) {
    <mat-error class="text-danger">
      {{ errorMessage }}
    </mat-error>
  }
</mat-form-field>
